import { API } from "../../utils/_HttpUtils";
import { user_routes as routes } from "../../constants/api-routes";

const size = 10;
const vouchersList = (from_date, to_date, fund_id, status, page) => {
    return new API()
        .send("GET", routes.vouchersList, null, null, {
            page,
            size,
            ...(from_date && { from_date }),
            ...(to_date && { to_date }),
            fund_id,
            ...(status && { status }),
        })
        .then((response) => Promise.resolve(response.data));
};

export { vouchersList };
